/**
 * Canonical app role kinds (from API `role.name` after {@link ./resolvePermissions.js#normalizeRoleName}).
 * Used for display / analytics only — access is driven by `role.permissions`, not role name.
 * Aliases: administrator→admin, dev→developer.
 */
export const APP_ROLE = Object.freeze({
  ADMIN: "admin",
  CLIENT: "client",
  DEVELOPER: "developer",
  MANAGER: "manager",
});
